import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { productQueries } from "@surgia/api/src/queryStore/admin/product";

interface UseAssignParentProductProps {
  tenantId: string;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

interface AssignParentProductParams {
  parentProductIds: number[];
}

export const useAssignParentProduct = ({
  tenantId,
  onSuccess,
  onError,
}: UseAssignParentProductProps) => {
  const queryClient = useQueryClient();

  const assignParentProductMutation = useMutation({
    ...productQueries.mutations.assignParentProducts(tenantId),
    onSuccess: (data) => {
      toast.success("Parent product's assignment was successful!");

      // Invalidate relevant queries to refetch data
      queryClient.invalidateQueries({
        queryKey: ["shared", "tenant-products"],
      });
      queryClient.invalidateQueries({
        queryKey: ["shared", "common-products"],
      });

      // Call custom onSuccess if provided
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (error) => {
      toast.error("Failed to assign parent products. Please try again.");
      // Call custom onError if provided
      if (onError) {
        onError(error);
      }
    },
  });

  const assignParentProducts = async (params: AssignParentProductParams) => {
    return assignParentProductMutation.mutateAsync(params);
  };

  return {
    assignParentProducts,
    assignParentProductMutation,
    isAssigning: assignParentProductMutation.isPending,
    isError: assignParentProductMutation.isError,
    error: assignParentProductMutation.error,
  };
};
